export default __webpack_public_path__ + "static/media/payment.29f092a0.svg";